function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.9,16.86l-.28-.54a10.13,10.13,0,0,0-1.48-2.44,1.18,1.18,0,0,0-1.39-.23,3.54,3.54,0,0,0-.7.59,2.4,2.4,0,0,1-1.5.5h-.49a2.32,2.32,0,0,1-1.54-.52,4.31,4.31,0,0,0-.7-.58,1.29,1.29,0,0,0-1.52.23,11.71,11.71,0,0,0-1.53,2.35v.07a1.6,1.6,0,0,1,1.59.44,12.46,12.46,0,0,1,.88,1.18h7.87A1.06,1.06,0,0,0,30,17.6,1,1,0,0,0,29.9,16.86Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79,20.08l-.27-.55A9.34,9.34,0,0,0,20,17.1a1.17,1.17,0,0,0-1.38-.25,3.65,3.65,0,0,0-.71.59,2.35,2.35,0,0,1-1.53.5h-.49a2.45,2.45,0,0,1-1.55-.51,5.61,5.61,0,0,0-.7-.59,1.25,1.25,0,0,0-1.5.23,11,11,0,0,0-1.58,2.35l-.11.22A1.58,1.58,0,0,1,12,20.1a9.77,9.77,0,0,1,.76,1.06H21a1.1,1.1,0,0,0,.93-.32A1,1,0,0,0,21.79,20.08Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,24.58a1.18,1.18,0,0,1-.93-.33c-.16-.21,0-.61,0-.84l.26-.55a11,11,0,0,1,1.53-2.41,1.26,1.26,0,0,1,1.51-.24,5.53,5.53,0,0,1,.7.58,2.37,2.37,0,0,0,1.49.52H8a2.33,2.33,0,0,0,1.54-.51,3.54,3.54,0,0,1,.7-.58,1.18,1.18,0,0,1,1.39.23A10.24,10.24,0,0,1,13.1,22.9l.27.54a1,1,0,0,1,.08.85,1.08,1.08,0,0,1-.92.3Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09,16.3a3.44,3.44,0,0,0,3.23-3.61V12.6a3.33,3.33,0,0,0-3.23-3.4H16a3.33,3.33,0,0,0-3.17,3.49v0A3.45,3.45,0,0,0,16.09,16.3Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,19.63A3.43,3.43,0,0,0,11,16V16a3.31,3.31,0,0,0-3.21-3.4h0A3.3,3.3,0,0,0,4.64,16h0A3.52,3.52,0,0,0,7.8,19.63Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.22,13.1A3.46,3.46,0,0,0,27.5,9.48v0h0A3.31,3.31,0,0,0,24.29,6h-.07A3.31,3.31,0,0,0,21,9.43h0A3.46,3.46,0,0,0,24.22,13.1Z",
    style: {
      fill: "#ccc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtual);
export default __webpack_public_path__ + "static/media/virtual.d9cb9374.svg";
export { ForwardRef as ReactComponent };